import { useCookies } from 'react-cookie'
import { useEffect, useState } from 'react'
import get from 'lodash/get'

/**
 * use query param ?{flagName}=1 to enable flag for this feature.
 * EX: const { enabled: featureFlagEnabled } = useFeatureFlag('feature_flag_pbac')
 */
const useFeatureFlag = (flagName: string) => {
    const [enabled, setEnabled] = useState(false)
    const [cookies, setCookie] = useCookies([flagName])

    useEffect(() => {
        const featureFlag = get(cookies, flagName)
        if (featureFlag) {
            console.log('Feature flag cookie is set: ' + flagName)
            setEnabled(true)
            return
        }

        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        if (urlParams) {
            const queryParam = urlParams.get(flagName)
            if (queryParam) {
                console.log('Enabling/setting feature flag cookie: ' + flagName)
                setEnabled(true)
                setCookie(flagName, true)
            }
        }
    }, [flagName, cookies, setCookie])

    return { enabled }
}

export default useFeatureFlag
